"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getMuiCard = getMuiCard;
function getMuiCard(palette) {
  return {
    defaultProps: {
      elevation: 4
    },
    styleOverrides: {
      root: {
        '&.MuiPaper-outlined': {
          boxShadow: 'none'
        },
        '.MuiCardContent-root': {
          '&:last-child': {
            padding: 0
          }
        },
        border: "solid 1px ".concat(palette.grey[300]),
        borderRadius: '6px',
        boxShadow: '0px 2px 6px rgba(51, 51, 51, 0.15)',
        padding: '25px 31px'
      }
    }
  };
}